module.exports = __webpack_public_path__ + "static/img/fea.593002e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/fea.png
// module id = ilBN
// module chunks = 1